import HB1416TrackingStudent from './HB1416TrackingStudent.component';

export default HB1416TrackingStudent;
